import Phaser from "phaser"
import { registerUser, getScoreRank } from "../../services/Request"

export default class GameOver extends Phaser.Scene {

    init(data) {
        this.playerRank = 0;
        this.playerRank = -1;
        this.isScoreSummited = false;
        if (data) {
            this.playerScore = data.s;
        }



    }

    preload() {
        this.load.audio('gameover-sound', require('../../assets/sounds/gameOver.mp3'));
        this.load.audio('click-sound', require('../../assets/sounds/click.mp3'));

        this.load.image("gameover-background", require('./assets/Background.png'));
        this.load.image("gameover-Your_Score_Is", require('./assets/Your_Score_Is.png'));
        this.load.image("gameover-Footer_Img", require('./assets/Footer_Img.png'));

        this.load.image("gameover-fields", require('./assets/fields.png'));

        this.load.image("gameover-Register_Leaderboard_Btn", require('./assets/Register_Leaderboard_Btn.png'));
        this.load.image("gameover-Play_Again_Btn", require('./assets/Play_Again_Btn.png'));

    }
    create() {

        this.gameOverSound = this.sound.add('gameover-sound', { volume: 0.5, loop: false });
        this.clickSound = this.sound.add('click-sound', { volume: 0.5, loop: false });
        this.gameOverSound.play();

        this.soundConfig();

        this.canvasWidth = this.game.config.width;
        this.canvasHeight = this.game.config.height;

        this.add.image(0, 0, "gameover-background").setOrigin(0, 0);
        this.add.image(this.canvasWidth / 2, 220, "gameover-Your_Score_Is");
        this.add.image(0, this.canvasHeight, "gameover-Footer_Img").setOrigin(0, 1);


        this.scoreLabel = this.add.text((this.canvasWidth / 2)-15, 510, this.playerScore, {
            color: '#FFF',
            boundsAlignH: "center", boundsAlignV: "middle",
            font: '300 300px Rockridge'
        }).setOrigin(0.5, 0.5);
        this.scoreLabel.setAlign('center');
        this.scoreLabel.setFixedSize(900,300);
        getScoreRank(this.playerScore, (rank) => {
            console.log(rank);
            if (rank < 9) {
                this.playerRank = rank;
                this.hasRank();
            } else {
                this.noRank();
            }
        })

        // this.backToMainMenu = this.add.text(1080 / 2, 1800, 'Back To Main', {
        //     fontFamily: 'Rockridge', color: '#F05B45', fontSize: 100,
        //     boundsAlignH: "center", boundsAlignV: "middle"
        // }).setOrigin(0.5, 0.5);



        // this.timeText.setTextBounds(0, 100, 800, 100);


        // const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        // const screenCenterY = this.cameras.main.worldView.y + this.cameras.main.height / 2;
        // const loadingText = this.add.text(screenCenterX, screenCenterY, 'Loading: 0%').setOrigin(0.5);

    }

    hasRank() {

        this.timeText = this.add.text(this.canvasWidth / 2, 700, "You're in the top #" + this.playerRank + " !", {
            color: '#FFF',
            boundsAlignH: "center", boundsAlignV: "middle",
            font: '300 65px Rockridge'
        }).setOrigin(0.5, 0.5);
        this.add.image(this.canvasWidth / 2, 830, "gameover-fields");
        this.add.image(this.canvasWidth / 2, 1000, "gameover-fields");
        var registerBtn = this.add.image(this.canvasWidth / 2, 1400, "gameover-Register_Leaderboard_Btn");


        var usernameInputField = this.add.rexInputText(this.canvasWidth / 2, 830, {
            width: 780,
            height: undefined,
            color: '#B2322F',
            placeholder: "Enter Your Username",
            fontSize: '48px',
            align: 'center',
            maxLength: 20,
            minLength: 5,
            fontFamily: 'Comfortaa'
        });
        var emailAddressInputField = this.add.rexInputText(this.canvasWidth / 2, 1000, {
            width: 780,
            height: undefined,
            color: '#B2322F',
            placeholder: "Enter Your Email Address",
            fontSize: '48px',
            align: 'center',
            type: 'email',
            minLength: 5,
            fontFamily: 'Comfortaa'

        });

        this.text01Content = this.add.text(this.canvasWidth / 2, 1200, "Please enter a valid email address. Winners will be contacted via email for prize collection.", {
            color: '#FFF',
            boundsAlignH: "center", boundsAlignV: "middle",
            font: '100 48px Rockridge'
        }).setOrigin(0.5, 0.5);
        this.text01Content.setWordWrapWidth(900);
        this.text01Content.setAlign('center');

        registerBtn.setInteractive();
        registerBtn.on('pointerdown', (pointer) => {
            this.clickSound.play();
            if (!this.isScoreSummited) {
                

                if (!usernameInputField.text || !emailAddressInputField.text) {
                 
                    this.text01Content.setText('Please enter a valid Username and Email Address', { font: '64px Arial', fill: '#ff0000' });
                    this.text01Content.setColor('#a80000');
                    this.text01Content.setDepth(2)
                    this.text01Content.setShadow(2, 2, '#ffffff', 4, true, true);
                    
                } else{
                    this.isScoreSummited = true;
                    registerUser(usernameInputField.text, emailAddressInputField.text, this.playerScore, () => {
                        this.scene.start('Leaderboard');
                    }, () => {
                        this.isScoreSummited = false;
                    });
                }

                
            }
        });



    }

    noRank() {
        var playAgainBtn = this.add.image(this.canvasWidth / 2, 750, "gameover-Play_Again_Btn");
        playAgainBtn.setInteractive();
        playAgainBtn.on('pointerdown', (pointer) => {
            this.clickSound.play();
            this.scene.start('CountDown');
        });
    }

    soundConfig(){
        this.clickSound.mute = !this.game.config.soundSetting;
        this.gameOverSound.mute = !this.game.config.soundSetting;
    }

    update() {

    }

}